/*
 * @Author: Yran
 * @Date: 2021-10-27 15:53:59
 * @LastEditors: Yran
 * @LastEditTime: 2021-10-27 16:07:09
 */
export const setCookie = function (nameKey, nameValue, expiresDays) {
    nameValue = encodeURIComponent(nameValue);
    var d = new Date();
    d.setTime(d.getTime() + (expiresDays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toGMTString();
    document.cookie = nameKey + '=' + nameValue + '; ' + expires;
};
export const getCookie = function (nameKey) {
    var name = nameKey + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0) { return c.substring(name.length, c.length); }
    }
    return '';
};
export const checkCookie = function (nameKey) {
    var user = getCookie(nameKey);
    if (user != '') {
        alert('欢迎 ' + user + ' 再次访问');
    }
    else {
        user = prompt('请输入你的名字:', '');
        if (user != '' && user != null) {
            setCookie(nameKey, user, 30);
        }
    }
};
export const deleteCookie = function (nameKey) {
    setCookie(nameKey, '', -100);
};